import axiosInstance from 'api/axiosInstance';

export interface PatrolSummaryParams {
  CustomerId: string | number;
  FromDate: string;
  ToDate: string;
  AddressId: string | number;
}

export interface PatrolSummary {
  comment_list_id: number;
  start_date: string;
  end_date: string;
  PatrolType: 'Static' | 'Mobile';
  activity_title: string;
  cust_name: string;
  assignment_start_time: string;
  address: string;
  comment: string;
  schedule_assignment_id: number;
  full_name: string;
  vv_file_id: string;
  dds_file_id: string;
  dds_archived: string;
  isIncident: string;
  hasChecklist: boolean;
  complete: string; // 'true'/'false' — from backend: end_date > start_date
  Checklists: []; // Always empty in summary - loaded on demand
}

export const getPatrolSummaries = async (
  params: PatrolSummaryParams
): Promise<PatrolSummary[]> => {
  try {
    const response = await axiosInstance.get(
      '/api/activityreportcontroller/GetPatrolSummaries',
      {
        params: params,
        paramsSerializer: (params) => `payload=${JSON.stringify(params)}`,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
        data: null,
      }
    );

    const data = response.data?.Data || response.data || [];
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Error fetching patrol summaries:', error);
    throw error;
  }
};

export default getPatrolSummaries;
